import styled from 'styled-components';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const Container = styled.div`
  width: 100%;
  max-width: 616px;
  padding: 0;
  background-color: ${COLOR.WHITE_1}; 
  margin: 0 auto; 
  padding: 24px 18px;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiSvgIcon-root {
    width: 22px;
    height: 22px;
  }

  .MuiIconButton-label {
    font-size: 18px;
    text-decoration: underline;
  }
`;

export const BoxText = styled.div`
    width: 100%;
    margin: 18px 0;
    ul, ol {
      list-style: disc;
      margin-left: 1.5rem;
    }
    li {
      line-height: 1.6;
      /* Tablet-notebook */
      @media screen and (min-width: ${BREAKPOINT.MD}) {
        font-size: 18px;
      }
    }
    a {
      cursor: pointer;
      text-decoration: underline;
      font-weight: 500;
      line-height: 1.6;
      color: ${COLOR.GREEN_1}; 
      /* Tablet-notebook */
      @media screen and (min-width: ${BREAKPOINT.MD}) {
        font-size: 18px;
      }
    }
`;

export const BoxOptin = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 42px 0 18px 0;
  span {
    padding-left: 0;
  }
  label {
    cursor: pointer;
    font-size: 16px;
    line-height: 125%;
    /* Tablet-notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      font-size: 18px;
    }
  }
`;

export const BoxButtons = styled.section`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 18px;

    button {
      width: 100% !important;
    }

    @media screen and (min-width: ${BREAKPOINT.MD}) {
      justify-content: flex-end;
      button:first-child {
        order: 1;
      }
      button {
        max-width: 258px;
      }
    }
`;
